// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3JTI3","buttons":"RemoveExpirationActionButtons_buttons__3BXoh"};